export const RECEIVE_ACCESS_TOKEN = "RECEIVE_ACCESS_TOKEN";
export const RECEIVE_ID_TOKEN = "RECEIVE_ID_TOKEN";
export const RECEIVE_PROFILE_DATA = "RECEIVE_PROFILE_DATA";
export const GENERATE_STATE_AND_NONCE = "GENERATE_STATE_AND_NONCE";

export const RECEIVE_EXPIRES_IN = "RECEIVE_EXPIRES_IN";

export const CLEAR_ALL = "CLEAR_ALL";
